<template>
    <div class="mt-12 max-lg:mt-[4em] max-lg:mb-[4em]">
        <h2 v-show="planoAtual.plano" class="text-center text-2xl">Informações do Plano</h2>   
        <div class="lg:mx-auto lg:w-[100%]">
            <div v-if="statusLoadingPlano" class="mt-[10em]">
                <LoadingLogo/>
            </div>
            
            <div class="lg:w-[100%] lg:h-auto mx-auto lg:mt-2 lg:mb-4">
                <div v-for="plano in planoAtual.plano" :key="plano.plano">
                    <div class="flex align-middle justify-center">
                        <div class="block rounded-lg shadow-md mt-6 bg-white w-[70%] max-lg:w-[97%] lg:h-[10rem] max-lg:h-[20rem]">
                            <div class="py-3 px-6 max-lg:px-2 h-full font-poppins border-b flex text-base border-gray-300 ">
                                <div class="w-full p-2 ">
                                    <span style="color: #006e63; font-weight: 550;">Plano</span><p class=" mb-1">{{plano.nome}}</p>
                                    
                                    <span style="color: #006e63; font-weight: 550; margin-top: 15px;">Período do Plano</span><p class="font-medium mb-2">{{plano.periodo_plano}}</p>
                                </div>
                                <div class="w-full p-2 mr-1 lg:ml-[6em]">
                                    <span style="color: #006e63; font-weight: 550;">Nº de Registro na ANS</span><p class="font-medium mb-2">{{plano.numero_protocolo}}</p>
                                    <span style="color: #006e63; font-weight: 550;">Situação</span><p class="font-medium">{{plano.baixa}}</p>
                                </div>
                                <div class="w-full p-2">
                                    <span style="color: #006e63; font-weight: 550;">Tipo de Contratação</span><p class="font-medium mb-1">{{plano.descricao_proposta_comercial}}</p>
                                </div>
                            </div>
                            <img class="w-[35px] relative mt-[-3.5rem] mr-[2rem] max-lg:mr-[1rem] float-right" src="@/assets/logoCortada.png" alt="">
                        </div>
                    </div>
                </div> 
            </div>    
        </div>
        <div>
            <h2 ref="ResultTitle" v-show="planoAtual.plano" class="text-center text-2xl mt-12">Resultados da Pesquisa</h2>
        </div>   
    </div>
</template>
  
<script>
    import LoadingLogo from './loadingLogo.vue';
    import { mapState } from 'vuex';

    export default {
    
    computed: {
        ...mapState(['planoAtual', 'statusLoadingPlano'])
    },

    methods: {
        getHeight(){
            setTimeout(() => {
                let elemento = this.$refs.ResultTitle.getBoundingClientRect().top; 
                this.$store.dispatch("loadHeight", {
                    altura: elemento - (elemento * 0.15)
                });
            }, 2000);
        },
    },

    updated(){
        this.getHeight();
    },

    components: { LoadingLogo }
}
</script>
  